import React from 'react';
import {
  Box,
  Button,
  IconButton,
  RefreshIcon,
  Text,
  TextInput,
  Tooltip,
} from '@razorpay/blade/components';
import type { LocalEntry } from './types';

export const AmountCell = ({
  row,
  amountValue,
  onAmountChange,
  onCalculate,
  onReCalculate,
  isCalculating,
  hasOvertimeHoursOrDays,
}: {
  row: LocalEntry;
  amountValue: string;
  onAmountChange: (params: { name?: string; value?: string }) => void;
  onCalculate: () => void;
  onReCalculate: () => void;
  isCalculating: boolean;
  hasOvertimeHoursOrDays: boolean;
}) => {
  if (row.isManuallyEdited || row.calculatedAmount !== null) {
    return (
      <Box display="flex" alignItems="center" gap="spacing.3">
        <Box width="80px">
          <TextInput
            accessibilityLabel="Overtime amount"
            name={`overtime-amount-${row.id}`}
            placeholder="0"
            value={amountValue}
            onChange={onAmountChange}
          />
        </Box>
        {row.isManuallyEdited && (
          <Tooltip content="Recalculate from formula" placement="top">
            <IconButton
              size="small"
              emphasis="subtle"
              icon={RefreshIcon}
              onClick={onReCalculate}
              accessibilityLabel="Recalculate overtime amount from formula"
            />
          </Tooltip>
        )}
      </Box>
    );
  }

  if (hasOvertimeHoursOrDays) {
    return (
      <Box display="flex" alignItems="center" gap="spacing.3">
        <Button variant="secondary" size="xsmall" onClick={onCalculate} isDisabled={isCalculating}>
          Calculate
        </Button>
      </Box>
    );
  }
  return (
    <Box display="flex" alignItems="center" gap="spacing.3">
      <Text color="surface.text.gray.muted">{'—'}</Text>
    </Box>
  );
};
